module.exports = __webpack_public_path__ + "img/BNB Chain.c27b7e66.png";